import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  EventCreatorHandler,
  EventCreatorRequest,
  EventCreatorResult,
} from '@libs/util-services';
import { EventCreatorModalComponent } from './event-creator-modal.component';

@Injectable({ providedIn: 'root' })
export class LessorEventCreatorHandler implements EventCreatorHandler {
  private readonly modalCtrl = inject(ModalController);

  async open(request: EventCreatorRequest): Promise<EventCreatorResult> {
    // Modal full-screen padrão (sem `breakpoints`/sheet mode) — alinhado com
    // EditorBlockPeriodComponent / EditorUnusualPeriodComponent / CourtInfoModal.
    // O sheet mode (`breakpoints: [0, 1]`) corta o `<ion-footer>` quando o
    // conteúdo do `<ion-content>` cresce, deixando os botões "Cancelar /
    // Confirmar reserva" inacessíveis.
    const modal = await this.modalCtrl.create({
      component: EventCreatorModalComponent,
      componentProps: {
        event: request.event,
        courtId: request.courtId,
        courtName: request.courtName,
        courtImage: request.courtImage,
        dateEvent: request.dateEvent,
        // Cliente já conhecido pela origem (ex: client-360 → "Agendar").
        // Sem repassar, o modal abria com o campo de atleta vazio e o
        // operador tinha que buscar de novo quem ele acabou de abrir.
        initialAthlete: request.initialAthlete,
      },
      // `modal-fullscreen` (definido em apps/lessor/src/global.scss:36) força
      // --width/--height: 100% em qualquer tamanho de tela. Sem isso, em
      // desktop/tablet o ion-modal vira card centrado e o ion-footer fica
      // visualmente sumido em vários cenários (ver evento-creator-modal.scss).
      cssClass: 'event-creator-modal modal-fullscreen',
      backdropDismiss: true,
      showBackdrop: true,
    });

    await modal.present();
    const { data } = await modal.onWillDismiss<EventCreatorResult>();

    return { created: data?.created ?? false };
  }
}
